import styled, { css } from 'styled-components'

export const SupportFileRowDesktop = styled.div`
  display: none;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;

  @media (min-width: 576px) {
    display: flex;
  }
`

export const SupportFileRowMobile = styled.div`
  margin-bottom: 8px;

  @media (min-width: 576px) {
    display: none;
  }
`

export const SupportFileMobileCard = styled.div`
  display: flex;
  align-items: center;
  background-color: #f7f8f9;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
`

export const SupportFileMobileContentWrap = styled.div`
  flex: 1;
  min-width: 0;
`

export const SupportFileContent = styled.div<{ $clickable?: boolean }>`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background-color: #f7f8f9;
  border-radius: 8px;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  flex: 1;
  min-width: 0;
`

export const SupportFileIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 12px;
  flex-shrink: 0;
`

export const SupportFileName = styled.span`
  color: #464646;
  font-size: 14px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const removeButtonStyles = css`
  background-color: #00599c;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;

  svg {
    font-size: 18px;
    color: white;
  }
`

export const SupportFileRemoveButton = styled.button`
  ${removeButtonStyles}
  width: 40px;
  height: 48px;
  border-radius: 4px;
`

export const SupportFileRemoveButtonMobile = styled.button`
  ${removeButtonStyles}
  width: 48px;
  height: 48px;
  border-left: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 0 8px 8px 0;
`

export const SupportFilePreviewIframe = styled.iframe`
  width: 100%;
  height: 70vh;
  border: none;
`
